import gql from 'graphql-tag'
import client from '@stores/apollo'
import { DateUtil, formatDate2 } from '@utils'
import handleFetchResult from '@utils/handleFetchResult'
import { ICalendar } from '@api/types'

interface IPayload {
  event: ICalendar
}

const mutateHandler = handleFetchResult<IPayload, IPayload>({
  handler: (data) => data,
  name: 'createCalendarEvent',
})

const DATE_PARSE_FORMAT = 'yyyy-MM-dd HH:mm:ss'

export function createCalendarEvent(id: string, startDate: DateUtil, endDate: DateUtil) {
  return client.gql
    .mutate({
      mutation: calendarEventMutation,
      variables: {
        input: {
          spaceId: id,
          start: formatDate2(startDate, DATE_PARSE_FORMAT),
          end: formatDate2(endDate, DATE_PARSE_FORMAT),
        },
      },
    })
    .then(mutateHandler)
}

const calendarEventMutation = gql`
  mutation ($input: CreateCalendarEventInput!) {
    createCalendarEvent(input: $input) {
      event {
        id
        start
        end
        summary
        options
        calendar {
          space {
            id
            externalId
            floor {
              id
              name
              code
              building {
                code
                timezone
                id
                name
                city
                timezone
                address
              }
            }
          }
        }
      }
    }
  }
`
